const wrapWithColor = (value: string, color: string) => `<span style="color: ${color}">${value}</span>`;

const valueDiff = ({
  oldValue = '',
  newValue = '',
}: {
  oldValue?: string;
  newValue?: string;
}) => ({
  hasChanged: oldValue !== newValue,
  oldValue: wrapWithColor(oldValue, 'red'),
  newValue: wrapWithColor(newValue, 'green'),
});

export default valueDiff;
